import {enumType} from '../common/enumType';

export const ShareFileFolderType = enumType({
   PERSONAL: 'Personal',
   SHARED: 'Shared',
});
